import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export const CREATE_PAYROLL_RULE = addAuthVars(gql`
  mutation createPayrollRule($name: String!, $config: [JSONObject]!) {
    createPayrollRule(name: $name, config: $config) {
      name
      config
    }
  }
`);

export const useCreatePayrollRule = () => {
  const [create, { loading, error }] = useMutation(CREATE_PAYROLL_RULE, {
    onError: error => {
      throw error;
    }
  });
  const createPayrollRule = async ({
    name,
    config
  }: {
    name: string;
    config: [JSON];
  }) => {
    await create({
      variables: {
        name,
        config
      },
      refetchQueries: ["payrollRules"]
    });
  };

  return { createPayrollRule, loading, error };
};
